require("bootstrap/js/src/collapse");

export default class SiteFooter {

    /**
     * @param {Main} mainInstance
     */
    constructor(mainInstance) {
        /**
         * @type {Main}
         */
        this.main = mainInstance;
        /**
         * @type {HTMLElement}
         */
        this.$el = document.getElementById("SiteFooter");
        if (this.$el) {
            /**
             * @type {HTMLElement}
             */
            this.$contentWrapper = document.getElementById("SiteContent");
            this.timeout = 0;

            // this.addToggleIconsToRootMenuItems();

            if (this.$el.classList.contains("revealing")) {
                window.addEventListener("resize", this.onUpdate.bind(this));
                window.addEventListener("load", this.onUpdate.bind(this));
            }
        }
    }

    adjustSizes() {
        if (this.$el.style["position"] === "fixed") {
            let $adminbar = document.getElementById("wpadminbar");
            let footerHeight = Math.round(this.$el.clientHeight - ($adminbar !== null ? $adminbar.clientHeight : 0));
            this.$contentWrapper.style.marginBottom = `${footerHeight}px`;
        }
        else {
            this.$contentWrapper.style.marginBottom = "";
        }
    }

    addToggleIconsToRootMenuItems() {
        /**
         * @type {Element|null}
         */
        this.$nav = this.$el.querySelector("nav.navigation .menu");
        if (this.$nav !== null) {
            this.$nav.classList.add("collapsible");

            this.$nav.querySelectorAll("> li").forEach(
                (item) => {
                    const $submenu = item.querySelector("> .sub-menu");
                    if ($submenu !== null) {
                        const $toggle = document.createElement("li");
                        const collapse = new bootstrap.Collapse($submenu, {
                            toggle: false
                        });

                        $toggle.classList.add("fas fa-plus");
                        item.append($toggle);

                        $toggle.addEventListener("click", (e) => {
                            if ($submenu.is(":visible")) {
                                collapse.hide();
                            }
                            else {
                                collapse.show();
                            }
                        });
                    }


                }
            )
        }

    }

    onUpdate(e) {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            this.adjustSizes();
        }, 50);
    }
}